import smoothscroll from 'smoothscroll-polyfill';

//  run smoothscroll polyfill
smoothscroll.polyfill();

const smoothScroll = (refs, parent, id) => {
  let currentItem = refs.current && refs.current.filter(
    (item) => item.current && item.current.innerHTML.indexOf(id) > 0 && { ...item.current });

  if (currentItem.length > 1) {
    currentItem = [currentItem[0]];
  }

  //  here is used smoothscroll polyfill
  if (currentItem && currentItem[0]) {
    currentItem[0].current.scrollIntoView({
      alignToTop: true,
      behavior: 'smooth'
    });
  }
};

export default smoothScroll;
